import { render, staticRenderFns } from "./ReviewRelease.vue?vue&type=template&id=3e046f26&scoped=true&"
import script from "./ReviewRelease.vue?vue&type=script&lang=ts&"
export * from "./ReviewRelease.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewRelease.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReviewRelease.vue?vue&type=style&index=1&id=3e046f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e046f26",
  null
  
)

export default component.exports